import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-trial-ended-cta",
  templateUrl: "./trial-ended-cta.component.html",
  styleUrls: ["./trial-ended-cta.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TrialEndedCtaComponent {
  @Input() public upgradeUrl: string;

  @Output() public downgradeClick = new EventEmitter<void>();
}
